import { Paragraph30 } from '@squareup/dex-ui-shared-base';
import React, { FC, PropsWithChildren } from 'react';

const MdxParagraph: FC<PropsWithChildren> = ({ children }) => {
  return <Paragraph30>{children}</Paragraph30>;
};

MdxParagraph.displayName = 'MdxParagraph';

export { MdxParagraph };
